import { Placeholder, Stack } from 'react-bootstrap';

export const JobDetailSkeleton = () => {
	return (
		<Stack className="job-detail-box bg-white">
			<div className="job-info d-flex align-items-center gap-3 position-relative">
				<div className="d-flex flex-column flex-md-row align-items-md-center flex-1 gap-3">
					<div className="company-logo"></div>
					<Stack className="job-detail justify-content-center flex-1">
						<Placeholder animation="glow">
							<Placeholder xs={12} size="lg" />
							<Placeholder xs={12} size="sm" />
						</Placeholder>
					</Stack>
				</div>
				<div className="apply-btn"></div>
			</div>
			<div className="employee-info">
				<div className="mb-3">
					<Placeholder animation="glow">
						<Placeholder xs={3} size="lg" />
					</Placeholder>
				</div>
				<div className="employee-info-content d-flex flex-wrap">
					<div className="employee-info-box d-flex align-items-center gap-2">
						<div className="w-100">
							<Placeholder animation="glow">
								<Placeholder xs={6} size="sm" />
								<Placeholder xs={8} size="lg" />
							</Placeholder>
						</div>
					</div>
					<div className="employee-info-box d-flex align-items-center gap-2">
						<div className="w-100">
							<Placeholder animation="glow">
								<Placeholder xs={6} size="sm" />
								<Placeholder xs={8} size="lg" />
							</Placeholder>
						</div>
					</div>
					<div className="employee-info-box d-flex align-items-center gap-2">
						<div className="w-100">
							<Placeholder animation="glow">
								<Placeholder xs={6} size="sm" />
								<Placeholder xs={8} size="lg" />
							</Placeholder>
						</div>
					</div>
					<div className="employee-info-box d-flex align-items-center gap-2">
						<div className="w-100">
							<Placeholder animation="glow">
								<Placeholder xs={6} size="sm" />
								<Placeholder xs={8} size="lg" />
							</Placeholder>
						</div>
					</div>
					<div className="employee-info-box d-flex align-items-center gap-2">
						<div className="w-100">
							<Placeholder animation="glow">
								<Placeholder xs={6} size="sm" />
								<Placeholder xs={8} size="lg" />
							</Placeholder>
						</div>
					</div>
					<div className="employee-info-box d-flex align-items-center gap-2">
						<div className="w-100">
							<Placeholder animation="glow">
								<Placeholder xs={6} size="sm" />
								<Placeholder xs={8} size="lg" />
							</Placeholder>
						</div>
					</div>
				</div>
			</div>
			<div className="basic-info">
				<div className="mb-3">
					<Placeholder animation="glow">
						<Placeholder xs={2} size="lg" />
					</Placeholder>
				</div>
				<Stack className="gap-2 gap-md-3">
					<div className="w-100">
						<Placeholder animation="glow">
							<Placeholder xs={1} size="sm" />
						</Placeholder>
					</div>
					<div className="w-100">
						<Placeholder animation="glow">
							<Placeholder xs={2} size="sm" />
						</Placeholder>
					</div>
					<div className="w-100">
						<Placeholder animation="glow">
							<Placeholder xs={3} size="sm" />
						</Placeholder>
					</div>
				</Stack>
			</div>
			<div className="job-description">
				<div className="mb-3">
					<Placeholder animation="glow">
						<Placeholder xs={1} size="lg" />
					</Placeholder>
				</div>
				<div className="key-skills-content">
					<Placeholder animation="glow">
						<Placeholder xs={2} /> <Placeholder xs={1} /> <Placeholder xs={2} />{' '}
					</Placeholder>
				</div>
			</div>
			<div className="job-description">
				<div className="mb-3">
					<Placeholder animation="glow">
						<Placeholder xs={1} size="lg" />
					</Placeholder>
				</div>
				<div className="job-description-content">
					<Placeholder animation="glow">
						<Placeholder xs={12} />
						<Placeholder xs={12} />
					</Placeholder>
				</div>
			</div>
			<div className="key-skills">
				<div className="mb-3">
					<Placeholder animation="glow">
						<Placeholder xs={2} size="lg" />
					</Placeholder>
				</div>
				<div className="key-skills-content">
					<Placeholder animation="glow">
						<Placeholder xs={2} /> <Placeholder xs={1} />{' '}
					</Placeholder>
				</div>
			</div>
		</Stack>
	);
};

export default JobDetailSkeleton;
